import axios from 'axios';
import { FileSignature, Eye, Download } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { openPdfBlob } from '../../utils/pdfOpener';

const STATUTS = {
  signe: { label: 'Signée', cls: 'bg-green-500 text-white' },
  en_attente_signature: { label: 'En attente de signature', cls: 'bg-amber-500 text-white' },
  en_attente: { label: 'En attente de signature', cls: 'bg-amber-500 text-white' },
};

const formatDateSignature = (conv) => {
  if (conv.signed_at) return new Date(conv.signed_at).toLocaleDateString('fr-FR');
  return conv.date_signature || null;
};

const ConventionFormationSection = ({ stagiaireId, stagiaire, conventionData }) => {
  const statut = conventionData
    ? (STATUTS[conventionData.statut] || { label: 'Brouillon', cls: 'bg-teal-500 text-white' })
    : { label: 'Non générée', cls: 'bg-slate-200 text-slate-600' };
  const dateSignature = conventionData ? formatDateSignature(conventionData) : null;
  const nomBase = `${(stagiaire?.user_info?.nom || '').replace(/\s+/g, '_')}_${(stagiaire?.user_info?.prenom || '').replace(/\s+/g, '_')}`.replace(/^_|_$/g, '') || 'Stagiaire';

  const handlePdf = async (mode) => {
    try {
      const res = await axios.get(`/candidats/${stagiaireId}/convention/pdf`, { responseType: 'blob' });
      openPdfBlob(res.data, `${nomBase}_Convention_Formation.pdf`, mode);
    } catch (e) {
      toast.error('Impossible de charger la convention de formation');
    }
  };

  return (
    <div className="bg-white border-2 border-teal-200 rounded-lg shadow-sm" data-testid="stagiaire-convention-formation-section">
      <div className="bg-teal-100/50 px-6 py-4 border-b border-teal-200">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-display font-semibold text-[#0F172A] flex items-center gap-2">
            <FileSignature className="h-5 w-5 text-teal-600" />
            Convention de formation
          </h2>
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${statut.cls}`} data-testid="stagiaire-convention-formation-statut">{statut.label}</span>
        </div>
      </div>
      <div className="p-6 space-y-3">
        {conventionData ? (
          <>
            <div className="bg-teal-50 rounded-lg p-3 border border-teal-100 text-sm space-y-1" data-testid="stagiaire-convention-formation-info">
              {conventionData.montant ? (
                <p><span className="text-slate-500">Montant :</span> <span className="font-semibold text-teal-700">{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(conventionData.montant)}</span></p>
              ) : null}
              <p><span className="text-slate-500">Date de signature :</span> <span className="font-medium">{dateSignature || '-'}</span></p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button variant="outline" size="sm" onClick={() => handlePdf('view')} className="border-teal-300 text-teal-700 hover:bg-teal-100" data-testid="stagiaire-btn-view-convention-formation" title="Prévisualiser">
                <Eye className="h-4 w-4" />
              </Button>
              <Button variant="outline" size="sm" onClick={() => handlePdf('download')} className="border-teal-300 text-teal-700 hover:bg-teal-100" data-testid="stagiaire-btn-download-convention-formation">
                <Download className="h-4 w-4 mr-1" />
                Télécharger
              </Button>
            </div>
          </>
        ) : (
          <p className="text-sm text-slate-500 text-center py-2">Aucune convention de formation disponible pour ce stagiaire.</p>
        )}
      </div>
    </div>
  );
};

export default ConventionFormationSection;
